module.exports = __webpack_public_path__ + "static/media/student30.bdc971cc.png";